'use client';

import React, { useEffect, useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Mail, Phone, SquareArrowRight, User } from 'lucide-react';
import { useSelector } from 'react-redux';
import { useRouter } from '@/lib/navigation';
import _ from 'lodash';
import { format } from 'date-fns';
import { setStateData } from '@flysync/shared-redux/slices/userSlice';
import { useDispatch } from 'react-redux';
import Link from '@/lib/app-link';
// import { config } from '@/config';
// import { useSelector } from 'react-redux';

const ViewBooking = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => state.user.stateData);

  const [bookingData, setBookingData] = useState({});
  // const bgImage = `/${config?.corporateName}/bg.png`;
  useEffect(() => {
    if (!_.isEmpty(userData)) {
      setBookingData(userData);
    } else {
      router.push('/booking');
    }
  }, [userData]);
  // useEffect(() => {
  //   if (router.query && Object.keys(router.query).length > 0) {
  //   }
  // }, [router.query]);

  // const userData = useSelector((state: any) => state.user);

  // const [user, setUser] = useState({
  //   name: '',
  //   email: '',
  //   phone: '',
  // });

  const handleCancellation = (tab: string) => {
    const cancellationType =
      tab.toLowerCase() == 'full cancellation' ? 'FR' : 'CN';
    const stateData = {
      ...bookingData,
      cancellationType,
      amendmentType: cancellationType,
    };
    dispatch(setStateData(stateData));
    router.push('/cancellation');
  };

  useEffect(() => {
    // console.log(userData, 'userData');
    // const userData = sessionStorage.getItem('user');
    // if (user) {
    //   useSelector(JSON.parse(user));
    // }
  }, []);

  return (
    <div className="bg-tertiary">
      <div
        className="h-14 w-full bg-primary sm:h-20 lg:h-48"
        // style={{ backgroundImage: `url(${bgImage})` }}
      />
      <div className="absolute inset-x-0 top-14 mx-auto px-1 pb-4 sm:top-14 sm:w-[1200px] sm:pb-8 lg:top-32 lg:pb-20">
        {/* Booking Success Header */}
        <div className="mb-4 flex flex-col items-start justify-between gap-2 sm:flex-row sm:items-end sm:gap-4">
          <div className="text-white">
            <h2 className="text-base font-semibold text-white sm:text-lg lg:text-xl">
              You have successfully booked your flight
            </h2>
            <div className="text-xs sm:text-sm">
              Booking ID:{' '}
              <span className="font-bold">{bookingData?.booking_code}</span>
            </div>
          </div>
          <div className="text-xs text-white/90 sm:text-sm">
            Booked on:{' '}
            {bookingData?.departure_date
              ? format(new Date(bookingData.departure_date), 'dd MMM yyyy')
              : 'N/A'}
          </div>
        </div>

        {/* Booking Details Card */}
        <div className="rounded-xl bg-white px-4 py-4 shadow-lg sm:px-6 sm:py-6 lg:px-24 lg:py-8">
          <div className="border-light rounded-xl border-2">
            {/* Route Header */}
            <div className="border-light border-b-2 px-3 py-3 text-sm font-bold text-zinc-800 sm:px-3 sm:py-4 sm:text-base md:px-4 lg:px-5 lg:py-5 lg:text-lg">
              {bookingData?.origin_city} - {bookingData?.destination_city}
            </div>

            {/* Cancellation Section */}
            {bookingData?.booking_status == 'CNF' && (
              <div className="border-light flex flex-row items-center justify-between gap-3 border-b-2 p-4 sm:gap-4 sm:p-6 lg:p-8">
                <h2 className="text-sm font-semibold text-zinc-800 sm:text-base">
                  Cancellation
                </h2>
                <Tabs
                  className="w-full sm:w-fit"
                  defaultValue="Full Cancellation"
                >
                  <TabsList className="flex h-fit w-full flex-col items-center gap-2 sm:w-auto sm:flex-row sm:gap-4">
                    {['Full Cancellation', 'Partial Cancellation'].map(
                      (tab) => (
                        <TabsTrigger
                          key={tab}
                          value={tab}
                          onClick={() => handleCancellation(tab)}
                          className={`w-full rounded border-2 text-xs text-zinc-800 transition-colors sm:w-auto sm:px-2 sm:py-1 sm:text-sm md:px-4 md:py-2 lg:px-4 lg:py-2 ${
                            tab === 'Full Cancellation'
                              ? `data-[state=active]:border-green-500 data-[state=inactive]:border-green-500 data-[state=active]:bg-green-500 data-[state=active]:text-white`
                              : `data-[state=active]:border-yellow-500 data-[state=inactive]:border-yellow-500 data-[state=active]:bg-yellow-500 data-[state=active]:text-white`
                          } `}
                        >
                          {tab}
                        </TabsTrigger>
                      ),
                    )}
                  </TabsList>
                </Tabs>
              </div>
            )}
            {/* Contact Information Section */}
            <div className="p-4 sm:p-6 lg:p-8">
              <h2 className="mb-2 text-sm font-semibold text-zinc-800 sm:text-base">
                Contact Information
              </h2>
              <div className="mb-4 text-xs text-zinc-600 sm:text-sm">
                Information about primary traveller. Any communication by
                airlines will be sent to these details.
              </div>

              <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center sm:gap-6">
                {/* Contact Details */}
                <div className="w-full space-y-3 sm:w-auto">
                  <div className="flex items-center gap-2">
                    <Mail className="h-4 w-4 text-gray-500" />
                    <span className="break-all text-xs sm:text-sm">
                      {bookingData?.email_id}
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone className="h-4 w-4 text-gray-500" />
                    <span className="text-xs sm:text-sm">
                      {bookingData?.mobile_number}
                    </span>
                  </div>
                </div>

                {/* E-Ticket Link */}
                {bookingData?.booking_status == 'CNF' && (
                  <Link
                    href={`/ticket?booking_id=${bookingData?.booking_id}`}
                    className="flex items-center gap-2 text-xs text-blue-500 transition-colors hover:text-blue-500/80 hover:underline sm:text-sm"
                  >
                    <SquareArrowRight className="h-4 w-4" />
                    <span>View E-Ticket</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBooking;
